// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-xlargeOnWide-text-454f63cd"};